// import WidgetPage from 'components/containers/Widget';
import withTilstandsrapport from 'lib/withTilstandsrapport';
import { NextPage } from 'next';
import dynamic from 'next/dynamic';
import Head from 'next/head';
import React from 'react';
import { connect } from 'react-redux';
import { AppState } from 'store';
import { getAddress } from 'store/tilstandsrapportEntities/tilstandsrapport/selectors';

const WidgetPage = dynamic(() => import('components/containers/Widget'), {
  ssr: false,
});

interface Props {
  tilstandsrapportId: string;
}

interface StateProps {
  address: string;
}

const Widget: NextPage<Props> = ({ address, tilstandsrapportId }: Props & StateProps) => {
  return (
    <>
      <Head>
        <title>{`${address} - Vendu Smart Boliganalyse`}</title>
        <script
          type="text/javascript"
          src="https://cdnjs.cloudflare.com/ajax/libs/iframe-resizer/3.5.8/iframeResizer.contentWindow.min.js"
        />
        <meta name="robots" content="noindex" />
        <meta name="googlebot" content="noindex" />
      </Head>
      <WidgetPage tilstandsrapportId={tilstandsrapportId} />
    </>
  );
};

const mapStateToProps = (state: AppState, ownProps): StateProps => ({
  address: getAddress(state, ownProps.tilstandsrapportId),
});

export default withTilstandsrapport(
  connect(
    mapStateToProps,
    null,
  )(Widget),
);
